import { motion } from 'framer-motion';
import React from 'react';

interface ServiceCardProps {
	title: string;
	description: string;
	icon?: React.ReactNode;
}

export default function ServiceCard({ title, description, icon }: ServiceCardProps) {
	const ref = React.useRef<HTMLDivElement>(null);

	function handleMouse(e: React.MouseEvent<HTMLDivElement>) {
		const el = ref.current;
		if (!el) return;
		const rect = el.getBoundingClientRect();
		const x = e.clientX - rect.left;
		const y = e.clientY - rect.top;
		el.style.setProperty('--x', `${x}px`);
		el.style.setProperty('--y', `${y}px`);
	}

	return (
		<motion.div
			ref={ref}
			onMouseMove={handleMouse}
			initial={{ opacity: 0, y: 12 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: true, amount: 0.3 }}
			transition={{ duration: 0.4 }}
			className="group relative overflow-hidden rounded-xl border border-gray-200 bg-white p-5 shadow-sm transition hover:-translate-y-1 hover:shadow-xl"
		>
			<div className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition" style={{ background: 'radial-gradient(600px circle at var(--x,50%) var(--y,50%), rgba(6,182,212,0.15), transparent 40%)' }} />
			<div className="absolute inset-0 rounded-xl pointer-events-none opacity-0 group-hover:opacity-100 transition bg-gradient-to-r from-babyblue via-royalpurple to-orangepeel" style={{ maskImage: 'linear-gradient(#000 0 0)', WebkitMaskImage: 'linear-gradient(#000 0 0)' }} />
			<div className="relative rounded-[10px] bg-white p-[1px]">
				<div className="rounded-[10px] bg-white p-0">
					<div className="mb-3 h-10 w-10 rounded-lg bg-primary/10 text-primary grid place-items-center">
						{icon}
					</div>
					<h3 className="text-lg font-semibold text-gradient">{title}</h3>
					<p className="mt-2 text-sm text-gray-600">{description}</p>
				</div>
			</div>
		</motion.div>
	);
}
